import React, { useState } from 'react';
import './side.css'
import Main from './table3'
import {  getsitedata,logout } from "./../action/user";
import DeleteConfirmationModal from './deleteConfirmationModal';

function Side() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const onlogout = async () => {
    var test =  await logout();
    window.location="/";
      }
    return (
        <div className='row'>
          <div className='col-md-2'>
        
        <div className="sidebar">
  <a  href='/myprofile'>என் சுயவிவரம்</a>
  <a className="active" href='/showCard'>நான் பார்த்த வரன்கள்</a>
  <a href='/anotherviewed'>என்னை பார்த்த வரன்கள்</a>
  <a href='/saved'>விருப்பமான வரன்கள்</a>
  <a href='/membership'>உறுப்பினர் விவரங்கள்</a>
  <a onClick={() => setIsModalOpen(true)} style={{ cursor: 'pointer' }}>
            கணக்கை நீக்கு
          </a>
  <a onClick={onlogout}>வெளியேறு</a>
</div>
</div>
<div className='col-md-10'>
<div className="contents dopp" >
 <Main/>
</div>
      </div>
      <DeleteConfirmationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
      </div>
    );
}
export default Side;